import { logError, logInfo } from "./logger";

export function testWebGLShaderSupport(): boolean {
  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl") ||
      (canvas.getContext("experimental-webgl") as WebGLRenderingContext | null);
    if (!gl) return false;

    const vsSource = `attribute vec4 position; void main() { gl_Position = position; }`;
    const fsSource = `void main() { gl_FragColor = vec4(1.0); }`;

    const vertexShader = gl.createShader(gl.VERTEX_SHADER);
    if (!vertexShader) return false;
    gl.shaderSource(vertexShader, vsSource);
    gl.compileShader(vertexShader);

    const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    if (!fragmentShader) return false;
    gl.shaderSource(fragmentShader, fsSource);
    gl.compileShader(fragmentShader);

    const program = gl.createProgram();
    if (!program) return false;
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);

    const success = gl.getProgramParameter(program, gl.LINK_STATUS) as boolean;
    if (success) {
      logInfo("WebGL shader support test passed", {
        source: "GPUHelpers",
      });
    } else {
      logError("WebGL shader support test failed", {
        source: "GPUHelpers",
      });
    }

    return success;
  } catch (error) {
    logError("Error testing WebGL shader support", {
      source: "GPUHelpers",
      // @ts-ignore
      errorMessage: error?.message || "Unknown error",
    });
    return false;
  }
}
